import { useEffect } from "react";
import { useRouter } from "next/router";

export const useHashScroll = (navHeight: number = 40) => {
  const router = useRouter();

  useEffect(() => {
    const handleHashScroll = () => {
      const hash = window.location.hash;
      if (hash) {
        setTimeout(() => {
          const element = document.querySelector(hash);
          if (element) {
            const elementTop =
              element.getBoundingClientRect().top + window.pageYOffset;
            const offsetTop = elementTop - navHeight;

            window.scrollTo({
              top: offsetTop,
              behavior: "smooth",
            });
          }
        }, 200);
      }
    };

    if (router.isReady) {
      handleHashScroll();
    }

    router.events.on("routeChangeComplete", handleHashScroll);

    return () => {
      router.events.off("routeChangeComplete", handleHashScroll);
    };
  }, [router.isReady, router.events, navHeight]);
};
